window.addEventListener('DOMContentLoaded', function() {
    var __comparePageCacheKey = '__compare_mig_page_data__';
    var __comparePageAttrCacheKey = '__compare_mig_page_attr__';
    var __ProductIds = getCompareCacheData();
    var __Features = getCompareAttrCacheData();
    if (__ProductIds.length <= 0) {
        __ProductIds.push('6913879015481');
        __ProductIds.push('7789166100537');
        __ProductIds.push('7538990186553');
        __ProductIds.push('7850768465977');
    }
    if (__Features.length <= 0) {
        $('.tr-item').each(function(){    
            __Features.push($(this).attr('data-attr'));
        });
    }
    //初始化table高度
    var tableHeight = $('.compare-table-box').offset().top;
    var tableHeight = $(window).height() - tableHeight;
    $('.compare-table-box').css('max-height', tableHeight + 'px');

    initSelect();
    
    function getCompareCacheData() {
        var cacheData = JSON.parse(window.localStorage.getItem(__comparePageCacheKey));
        var cacheData = cacheData ? cacheData : ['6913879015481','7789166100537','7538990186553','7850768465977'];
        return cacheData;
    }
    function getCompareAttrCacheData() {
        var cacheData = JSON.parse(window.localStorage.getItem(__comparePageAttrCacheKey));
        var cacheData = cacheData ? cacheData : [];
        return cacheData;
    }

    function addFeaturesAttr(attr){
        var index = __Features.indexOf(attr);
        if (index === -1) {    __Features.push(attr);}
        window.localStorage.setItem(__comparePageAttrCacheKey, JSON.stringify(__Features));
        initSelect();
    }
    function delFeaturesAttr(attr){
        var index = __Features.indexOf(attr);
        if (index !== -1) {    
            __Features.splice(index, 1);
        }
        window.localStorage.setItem(__comparePageAttrCacheKey, JSON.stringify(__Features));
        initSelect();
    }

    function addProductId(pid){
        var index = __ProductIds.indexOf(pid);if (index === -1) {    
            __ProductIds.push(pid);
        }
        window.localStorage.setItem(__comparePageCacheKey, JSON.stringify(__ProductIds));
        initSelect();
    }
    function delProductId(pid){
        var index = __ProductIds.indexOf(pid);
        if (index !== -1) {    
            __ProductIds.splice(index, 1);
        }
        var index2 = __ProductIds.indexOf(Number(pid));
        if (index2 !== -1) {    
            __ProductIds.splice(index2, 1);
        }
        window.localStorage.setItem(__comparePageCacheKey, JSON.stringify(__ProductIds));
        initSelect();
    }
    function initSelect() {
        var productIds = __ProductIds;
        var features = __Features;
        $('.compare-table').hide();
        $('.show-flag').hide();
        $('.model-num').html(productIds.length);
        $('.features-num').html(features.length);
        $('.search-select-model .search-item input').prop('checked', false);
        if (productIds.length > 0) {    
            productIds.forEach(item => {        
                $('.show-' + item).show();        
                $('.search-select-model .search-item input[data-id="' + item + '"]').prop('checked', true);    
            });
        } 
        $('.search-select-features .search-item input').prop('checked', false);
        if (features == 'all') {    
            $('.compare-table .tr-item').show();    
            $('.search-select-features .search-item input').prop('checked', true);
        } else {    
            $('.compare-table .tr-item').hide();    
            features.forEach(item => {        
                $('.compare-table tr[data-attr="' + item + '"]').show();        
                $('.search-select-features .search-item input[data-attr="' + item + '"]').prop('checked', true);    
            });    
            $('.compare-table').show();
        }
        $('.compare-table').show();
    }
    $('.search-item').click(function(event){
        $(this).find('input').click();
        event.stopPropagation();
    });
    $('.search-select-model .search-item input').click(
        function(event){
            var pid = $(this).attr('data-id');
            if ($(this).prop('checked') == true) {    
                addProductId(pid);
            } else {    
                delProductId(pid);
            }
            event.stopPropagation();
        }
    );
    $('.search-select-features .search-item input').click(
            function(event){
            var attr = $(this).attr('data-attr');
            if ($(this).prop('checked') == true) {    
                addFeaturesAttr(attr);
            } else {    
                delFeaturesAttr(attr);
            }
            event.stopPropagation();
        }
    );
    $('.search-select-model .action-btn').click(
        function(event){
            __ProductIds = [];
            if ($(this).attr('data-flag') == 'all') {    
                $('.search-select-model .search-item input').each(function(){        
                    __ProductIds.push($(this).attr('data-id'));    
                });
            }
            initSelect();
            window.localStorage.setItem(__comparePageCacheKey, JSON.stringify(__ProductIds));
            event.stopPropagation();
        }
    );
    $('.search-select-features .action-btn').click(
        function(event){
            __Features = [];
            if ($(this).attr('data-flag') == 'all') {    
                $('.search-select-features .search-item input').each(function(){        
                    __Features.push($(this).attr('data-attr'));    
                });
            }
            initSelect();
            window.localStorage.setItem(__comparePageAttrCacheKey, JSON.stringify(__Features));
            event.stopPropagation();
        }
    );
    $('.del-btn').click(function(){
        var pid = $(this).attr('data-id');
        delProductId(pid);
    });
    $('.search-select-btn').click(
        function(event){
            $('.search-sub-options').hide();
            $(this).parent().find('.search-sub-options').show();
            event.stopPropagation();
        }
    );
    $(window).click(function(){
        $('.search-sub-options').hide();
    });
    $('.img-page-btn').click(function(){
        var dataKey = $(this).attr('data-key');
        $(this).parent().parent().find('.img-item').hide();
        $(this).parent().parent().find('div[data-flag="' + dataKey + '"]').show();
    });
    $('.search-sub-options').click(function(event){
        event.stopPropagation();
    });
    $('.search-select .close-option').click(function(){
        $(this).parent().parent().parent().hide();
    });
});